import { inject, InjectionToken, Provider, TemplateRef } from '@angular/core';
import { TasksFacadeService } from '@data-access/tasks/facade';
import { TaskListSignalState } from '@data-access/tasks/types';
import { TASK_LIST_SIGNAL_STORE } from '../signal-store';

export const DEFAULT_TASK_TOKEN = new InjectionToken<TaskListSignalState>('Tasks');

export function taskTokenizer() {
  return inject(DEFAULT_TASK_TOKEN);
}

export const TASK_PROVIDER: Provider = {
  provide: DEFAULT_TASK_TOKEN,
  useClass: TASK_LIST_SIGNAL_STORE,
};

export const TASK_FACADE_SERVICE = new InjectionToken<TasksFacadeService>(
  'TasksFacadeService',
);
/*
 * Token fro side nav
 */
export const TASK_CONFIGURATION_TOKEN = new InjectionToken<
  (tmpRef: TemplateRef<unknown>) => void
>('Template Projection for Task Configuration');
